module.exports = __webpack_public_path__ + "media/images/flags/1x1/hti-dc2a30a22cc2b3fd628381b5297703ce.svg";